import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { Segment, Button, Form } from 'semantic-ui-react';

const ConformiteAdd4 = ({ prev, next }) => {
  const initialValues = {
    firstname: '',
    lastname: '',
    telephone: '',
    email: '',
    company: '',
    complaintType: '',
    title: '',
    description: '',
    createdAt: '',
    confirmation: ''
  };

  const validationSchema = Yup.object().shape({});

  const handleSubmit = (values) => {
    values.createdAt = Date.now();

    //alert(JSON.stringify(values, null, 2));

    next();
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <Form size="large" onSubmit={handleSubmit}>
          <Segment.Group>
            <Segment textAlign="center">TODO 4</Segment>

            <Segment textAlign="center">
              <Button.Group>
                <Button
                  onClick={prev}
                  fluid
                  to="#"
                  type="submit"
                  floated="right"
                  content="Precedent"
                />
                <Button.Or text="OU" />
                <Button fluid type="submit" floated="right" positive content="Soumettre" />
              </Button.Group>
            </Segment>
          </Segment.Group>
        </Form>
      )}
    </Formik>
  );
};

export default ConformiteAdd4;
